import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { contactDetails } from '../data/house';
import { brand } from '../data/brand';
import { Logo } from './Logo';
const columns = [{
  title: 'Stay',
  links: [{
    to: '/accommodations',
    label: 'Apartments'
  }, {
    to: '/booking',
    label: 'Book a stay'
  }, {
    to: '/booking?type=photoshoot',
    label: 'Book a photoshoot'
  }]
}, {
  title: 'Explore',
  links: [{
    to: '/experiences',
    label: 'Experiences'
  }, {
    to: '/gallery',
    label: 'Gallery'
  }, {
    to: '/about',
    label: 'About & house rules'
  }]
}];
export function Footer() {
  return <footer className="relative overflow-hidden bg-forest-700 text-ivory-200" data-id="element-282" data-mp="3qcx86ace0m2q">
      <div className="mx-auto max-w-[1240px] px-5 py-16 sm:px-8 lg:px-12 lg:py-20" data-id="element-283" data-mp="29zgl41oc4umn">
        <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr_1fr_1.3fr]" data-id="element-284" data-mp="2a1jkhcbdo041">
          <div data-id="element-285" data-mp="2ezl3xycpu1g1">
            <Logo tone="light" size="lg" data-id="element-286" data-mp="2ew72qtfsfya6" />
            <p className="mt-6 font-display text-lg text-gold-300" data-id="element-287" data-mp="3l8qvw2zluhqx">{brand.tagline}</p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-ivory-200/70" data-id="element-288" data-mp="3gaz3z8yymvmq">{brand.promise}</p>
          </div>

          {columns.map(column => <div key={column.title} data-id="element-289" data-mp="3v916dfu99b2e">
              <p className="text-[10px] uppercase tracking-overline text-gold-300" data-id="element-290" data-mp="3q8wpvptckgc6">{column.title}</p>
              <ul className="mt-5 space-y-3" data-id="element-291" data-mp="82qplkz0zfq1">
                {column.links.map(link => <li key={link.to} data-id="element-292" data-mp="3472viclxzwm">
                    <Link to={link.to} className="text-sm text-ivory-200/80 transition-colors duration-150 ease-premium hover:text-gold-300" data-id="element-293" data-mp="335ujlmz7ril">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}

          <div data-id="element-294" data-mp="ms6fyzun9j57">
            <p className="text-[10px] uppercase tracking-overline text-gold-300" data-id="element-295" data-mp="mspndmmo4p4z">Reach us</p>
            <ul className="mt-5 space-y-3 text-sm text-ivory-200/80" data-id="element-296" data-mp="tvmpjfil4cku">
              <li data-id="element-297" data-mp="tta06hahyzxr">
                <a href={contactDetails.phoneHref} className="inline-flex items-start gap-2.5 transition-colors duration-150 ease-premium hover:text-gold-300" data-id="element-298" data-mp="ytxyzp4ywl2j">
                  <PhoneIcon size={15} className="mt-0.5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-299" data-mp="18k943f0e10b0" />
                  {contactDetails.phone}
                </a>
              </li>
              <li data-id="element-300" data-mp="1hkfe2qwvni5f">
                <a href={contactDetails.emailHref} className="inline-flex items-start gap-2.5 transition-colors duration-150 ease-premium hover:text-gold-300" data-id="element-301" data-mp="1hjw6a30xya54">
                  <MailIcon size={15} className="mt-0.5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-302" data-mp="1rhtrehni7qti" />
                  {contactDetails.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-303" data-mp="3t9q7m4km9oum">
                <MapPinIcon size={15} className="mt-0.5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-304" data-mp="3tccdlzruzwaq" />
                <span data-id="element-305" data-mp="2ah824nnoyura">{contactDetails.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-ivory-100/10 pt-6 text-xs text-ivory-200/55 sm:flex-row sm:items-center sm:justify-between" data-id="element-306" data-mp="21mtik8w4oy2d">
          <p data-id="element-307" data-mp="1wpa4b8zfklaf">© {new Date().getFullYear()} Bel Air Luxury Apartment. All rights reserved.</p>
          <p data-id="element-308" data-mp="2tdg1xbxxqdf7">Check-in 2 PM · Checkout 12 noon</p>
        </div>
      </div>
    </footer>;
}